import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { googleLogin } from '../../Redux/Actions/UserAction';
import Swal from 'sweetalert2';

const GoogleCallback = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const handleGoogleCallback = async () => {
      try {
        // Get the authorization code from URL parameters
        const urlParams = new URLSearchParams(location.search);
        const code = urlParams.get('code');
        const error = urlParams.get('error');

        if (error) {
          console.error('Google OAuth error:', error);
          Swal.fire({
            title: 'Login Failed',
            text: 'There was an error with Google login. Please try again.',
            icon: 'error',
            confirmButtonText: 'OK'
          });
          window.location.href = '#/login';
          return;
        }

        if (code) {
          console.log('Google authorization code received:', code);
          
          // Prepare data for backend
          const googleData = {
            code: code,
            scope: 'openid email profile'
          };

          // Dispatch Google login action
          dispatch(googleLogin(googleData));
          
        } else {
          console.error('No authorization code received');
          Swal.fire({
            title: 'Login Failed',
            text: 'No authorization code received from Google. Please try again.',
            icon: 'error',
            confirmButtonText: 'OK'
          });
          window.location.href = '#/login';
        }
      } catch (error) {
        console.error('Error processing Google callback:', error);
        Swal.fire({
          title: 'Login Failed',
          text: 'An error occurred during login. Please try again.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
        window.location.href = '#/login';
      }
    };

    // Check if we have OAuth parameters
    const urlParams = new URLSearchParams(location.search);
    const hasCode = urlParams.get('code');
    const hasError = urlParams.get('error');
    
    if (!hasCode && !hasError) {
      // No OAuth parameters, redirect to login
      window.location.href = '#/login';
      return;
    }

    // Process OAuth callback
    handleGoogleCallback();
  }, [dispatch, location, history]);

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
      <div className="text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3">Processing Google login...</p>
      </div>
    </div>
  );
};

export default GoogleCallback;
